import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import React, { useEffect, useRef } from "react";
import "./App.scss";
import Home from "./pages/Home";
import Error404 from "./pages/Error404";
import Dashboard from "./pages/Dashboard";
import MobileOTP from "./pages/MobileOTP";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import MyProfile from "./pages/MyProfile";
import 'react-loading-skeleton/dist/skeleton.css'
import 'mdbreact/dist/css/mdb.css';
import AllProcessName from "./pages/process/AllProcessName";
import ProcessReport from "./pages/process/ProcessReport";
import FacebookAuth from "./pages/facebook/FacebookAuth";
import GoogleAuth from "./pages/google/GoogleAuth";
import ProcessDetailReport from "./pages/process/ProcessDetailReport";
import ProcessDetails from "./pages/report/ProcessDetails";
import CenterPerformance from "./pages/report/CenterPerformance";
import CenterHeadPerformance from "./pages/report/CenterHeadPerformance";
import AgentPerformance from "./pages/report/AgentPerformance";
import YesterdayCallCount from "./pages/report/YesterdayCallCount";
import LastWeekCall from "./pages/report/LastWeekCall";
import TodayTeamCall from "./pages/report/TodayTeamCall";
import DayWiseWithCompare from "./pages/report/DayWiseWithCompare";
import AdsOverview from "./pages/AdsOverview";
import TodayLiveCall from "./pages/report/TodayLiveCall";
import YesterdayTeamCall from "./pages/report/YesterdayTeamCall";
import TopProductsByStateReport from "./pages/report/TopProductsByStateReport";
import ProductPerformance from "./pages/report/ProductPerformance";
import TopProductsByClusterReport from "./pages/report/TopProductsByClusterReport";

function AppWithInactivity() {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  const INACTIVITY_TIMEOUT = 2 * 60 * 60 * 1000;

  const handleLogout = () => {
    localStorage.clear();
    toast.warning("You have been logged out due to inactivity.");
    navigate("/");
  };

  const startInactivityTimer = () => {
    timeoutRef.current = setTimeout(() => {
      handleLogout();
    }, INACTIVITY_TIMEOUT);
  };

  const resetInactivityTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    startInactivityTimer();
  };

  useEffect(() => {
    document.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });

    const disableShortcuts = (e) => {
      if (e.key === "F12") {
        e.preventDefault();
      }

      if (e.ctrlKey && e.shiftKey && e.key === "I") {
        e.preventDefault();
      }

      if (e.ctrlKey && e.key === "u") {
        e.preventDefault();
      }

      if (e.ctrlKey && e.key === "U") {
        e.preventDefault();
      }

      if (e.ctrlKey && e.shiftKey && e.key === "J") {
        e.preventDefault();
      }

      if (e.ctrlKey && e.shiftKey && e.key === "l") {
        e.preventDefault();
      }

      if (e.ctrlKey && e.shiftKey && e.key === "C") {
        e.preventDefault();
      }
    };

    document.addEventListener("keydown", disableShortcuts);

    document.addEventListener("mousemove", resetInactivityTimer);
    document.addEventListener("keydown", resetInactivityTimer);
    document.addEventListener("click", resetInactivityTimer);

    startInactivityTimer();

    return () => {
      document.removeEventListener("mousemove", resetInactivityTimer);
      document.removeEventListener("keydown", resetInactivityTimer);
      document.removeEventListener("click", resetInactivityTimer);
      document.removeEventListener("contextmenu", (e) => e.preventDefault());
      document.removeEventListener("keydown", disableShortcuts);

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mobile-otp" element={<MobileOTP />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/my-profile" element={<MyProfile />} />
        <Route path="/all-process" element={<AllProcessName />} />
        <Route path="/process-report" element={<ProcessReport />} />
        <Route path="/facebook-auth" element={<FacebookAuth />} />
        <Route path="/google-auth" element={<GoogleAuth />} />
        <Route path="/process-report/:slug" element={<ProcessDetailReport />} />
        <Route path="/process-details" element={<ProcessDetails />} />
        <Route path="/center-performance-report" element={<CenterPerformance />} />
        <Route path="/center-head-performance-report/:slug" element={<CenterHeadPerformance />} />
        <Route path="/agent-performance-report" element={<AgentPerformance />} />
        <Route path="/yesterday-call-report" element={<YesterdayCallCount />} />
        <Route path="/last-week-call-report" element={<LastWeekCall />} />
        <Route path="/today-team-report" element={<TodayTeamCall />} />
        <Route path="/day-wise-report" element={<DayWiseWithCompare />} />
        <Route path="/ads-overview" element={<AdsOverview />} />
        <Route path="/today-live-call-reports" element={<TodayLiveCall />} />
        <Route path="/yesterday-team-call-report" element={<YesterdayTeamCall />} />
        <Route path="/top-product-by-state" element={<TopProductsByStateReport />} />
        <Route path="/product-performance-report" element={<ProductPerformance />} />
        <Route path="/top-product-by-cluster-head" element={<TopProductsByClusterReport />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
      <ToastContainer position="bottom-center" />
    </>
  );
}

function App() {
  return (
    <>
      <BrowserRouter>
        <AppWithInactivity />
      </BrowserRouter>
    </>
  );
}

export default App;
